import { operators as o } from '@pendo/aggregations';
import { PRODUCT_AREAS } from '@/utils/aggregation';

const { VOC, VALIDATE } = PRODUCT_AREAS || {};

export default {
    name: 'VocItemsCount',
    productArea: VOC,
    subProductArea: VALIDATE,
    responseFormat: 'row',
    build: ({ appId = 'expandAppIds("*")', type = 'idea' }) => {
        const pipeline = o.pipeline(o.sources.vocItems({ appId, type }), o.select({ id: 'id' }), o.count(null));

        return pipeline;
    },
};
